import * as Yup from 'yup';

export const confirmCodeSchema = Yup.object().shape({
  code: Yup.string()
  .required('Pleae enter a valid code.'),
})